import { ChakraProvider } from '@chakra-ui/react'
import { Global } from '@emotion/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import IconLibrary from 'assets/icons'
import { ApiContextProvider } from 'contexts/api-context'
import { UserContextProvider } from 'contexts/user-context'
import { FBXSRouterProvider } from 'router'
import { overrideVideoJsErrorLogging } from 'utils/video-utils'

import theme from 'theme'

// Load Font Awesome icon library
IconLibrary()

// Override video.js error logging
overrideVideoJsErrorLogging()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: query => query.state.status !== 'error',
      staleTime: 1000,
    },
  },
})

export function App() {
  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_OAUTH_APP_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <UserContextProvider>
          <ApiContextProvider>
            <ChakraProvider theme={theme}>
              <FBXSRouterProvider />
              <Global
                styles={{
                  body: {
                    backgroundColor: theme.baseColors.background.default,
                    overscrollBehaviorY: 'none',
                  },
                }}
              />
            </ChakraProvider>
          </ApiContextProvider>
        </UserContextProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  )
}
